import { startLogin } from '../auth/useAuth'

/**
 * Login screen. Single sign-in-with-Google button — matches the locked-in
 * gated-login decision (everything behind auth).
 */
export function Login() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-6">
      <div className="w-full max-w-sm text-center">
        <h1 className="mb-2 font-serif text-[2.5rem] leading-none tracking-tight text-ink">
          writers-block
        </h1>
        <p className="mb-8 font-serif italic text-ink-muted">
          a quiet place to write
        </p>
        <button
          onClick={() => startLogin()}
          className="flex w-full items-center justify-center gap-2 rounded border border-border bg-paper px-4 py-2.5 font-serif text-[14px] text-ink transition-colors hover:bg-surface-hover"
        >
          <GoogleGlyph />
          <span>continue with Google</span>
        </button>
        <p className="mt-6 text-[11px] text-ink-muted">
          we only read your name + email for the account.
        </p>
      </div>
    </div>
  )
}

function GoogleGlyph() {
  return (
    <svg width={16} height={16} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"
      />
    </svg>
  )
}
